import classNames from 'clsx';
import React from 'react';
import Image from '../../resolvers/Image';
import Link from '../../resolvers/Link';
import Text from '../UI/Text';

export default function ArticleCard({
  data,
  className,
  variant,
  featured = false,
}) {
  const { node: post } = data;

  const isSide = variant === 'side';

  return (
    <article className={classNames('@container', className)}>
      <Link
        to={`/blog/${post.slug}/`}
        className={classNames(
          '',
          {
            '@2xl:flex @2xl:justify-between @2xl:gap-12 @5xl:gap-32': !isSide,
          },
          {
            'flex h-full justify-between gap-6 md:@lg:gap-14': isSide,
          },
        )}>
        <div
          className={classNames(
            'block overflow-hidden rounded-lg bg-blue-900 object-cover',
            {
              'mb-10 aspect-[3/2] @2xl:mb-0 @2xl:aspect-auto @2xl:w-1/2':
                variant === 'default',
            },
            {
              'w-1/2 md:@lg:w-2/3': isSide,
            },
          )}>
          <Image
            src={post.localFeatureImage || post.feature_image}
            loading='lazy'
            className='h-full w-full rounded-lg object-cover'
          />
        </div>

        <div
          className={classNames(
            {
              '@xl:py-10 @4xl:py-10': !isSide,
            },
            {
              'flex w-full max-w-md flex-col justify-center py-6 md:py-0 md:@md:py-6 md:@lg:py-8': isSide,
            },
          )}>
          <h2
            className={classNames(
              'font-heading font-semibold',
              {
                'mb-4 text-xl @lg:text-2xl @2xl:text-4xl @5xl:text-6xl': !isSide,
              },
              {
                'text-md @md:text-lg md:@lg:text-2xl': isSide,
              },
            )}>
            {post.title}
          </h2>
          {post.excerpt && (
            <Text
              className={classNames(
                'content my-3',
                {
                  'mb-8 text-md @5xl:text-lg': !isSide,
                },
                {
                  'hidden md:@lg:block': isSide,
                },
              )}>
              {post.excerpt}
            </Text>
          )}

          {post.primary_author && (
            <div
              className={classNames('flex items-center gap-4', {
                'mt-auto py-4 md:@lg:mt-0': isSide,
              })}>
              <div
                className={classNames(
                  'h-12 w-12 overflow-hidden rounded-full',
                  {
                    'hidden md:@lg:block': isSide,
                  },
                )}>
                <Image
                  src={post.primary_author?.profile_image?.replace(250, 50)}
                  alt={post.primary_author.name}
                  className='bg-red h-12 w-12 rounded-full object-cover'
                />
              </div>
              <div>
                <div
                  className={classNames('text-sm font-semibold leading-tight', {
                    'text-xs md:@lg:text-sm': isSide,
                  })}>
                  {post.primary_author?.name}
                </div>
                <div
                  className={classNames('text-sm leading-tight text-gray-700', {
                    'hidden md:@lg:block': isSide,
                  })}>
                  {post.reading_time} min read{' '}
                </div>
              </div>
            </div>
          )}
        </div>
      </Link>
    </article>
  );
}
